import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ApplicationFacade, RelatedCardFacade } from '@ridango/components';

@Component({
    selector: 'rwidget-purchase-summary',
    templateUrl: './purchase-summary.component.html',
    styleUrls: []
})
export class PurchaseSummaryComponent {
    @Input() flowCompleted = false;
    @Input() tickets = [];
    @Input() locale;
    @Input() hasZoneModal = false;
    @Input() cards = [];

    @Output() postPayloads = new EventEmitter();
    @Output() requestRemoveCard = new EventEmitter();

    assetsPath$ = this.applicationFacade.assetsPath$;
    relatedCardsNormalized$ = this.relatedCardFacade.allNormalized$;

    constructor(
        private applicationFacade: ApplicationFacade,
        private relatedCardFacade: RelatedCardFacade
    ) {}

    postToCart() {
        this.postPayloads.emit();
    }

    removeCard($event) {
        this.requestRemoveCard.emit($event);
    }
}
